import React from "react";
import { ReportLinkCardProps } from "./report-link-card.props";
import ReportLinkCardEnum from "../../enums/report-link-card.enum";
import classMap from "../../helpers/classMap";
import FaIcon from "../fa-icon/fa-icon";
import diagnosticImg from "../../assets/report-link-card/diagnostic.svg";
import benchmarkPerformanceImg from "../../assets/report-link-card/benchmark-performance.svg";
import formativesImg from "../../assets/report-link-card/formatives.svg";
import screenerImg from "../../assets/report-link-card/screener.svg";
import cumulativeStandardsImg from "../../assets/report-link-card/cumulative-standards.svg";
import cumulativePerformanceImg from "../../assets/report-link-card/cumulative-performance.svg";
import usageImg from "../../assets/report-link-card/usage.svg";
import growthUsageImg from "../../assets/report-link-card/growth-usage.svg";
import "./report-link-card.scss";

const reportImages: { [key in ReportLinkCardEnum]: any } = {
  [ReportLinkCardEnum.DIAGNOSTIC]: diagnosticImg,
  [ReportLinkCardEnum.FORMATIVES]: formativesImg,
  [ReportLinkCardEnum.SCREENER]: screenerImg,
  [ReportLinkCardEnum.BENCHMARK_PERFORMANCE]: benchmarkPerformanceImg,
  [ReportLinkCardEnum.CUMULATIVE_STANDARDS]: cumulativeStandardsImg,
  [ReportLinkCardEnum.CUMULATIVE_PERFORMANCE]: cumulativePerformanceImg,
  [ReportLinkCardEnum.USAGE]: usageImg,
  [ReportLinkCardEnum.GROWTH_USAGE]: growthUsageImg
};

const ReportLinkCard = (props: ReportLinkCardProps) => {
  const { title, description, image, onClick, icon, mpngStyle, className } = props;

  return (
    <button
      className={classMap("report-link-card", className, mpngStyle ? "mpng-style" : "")}
      onClick={() => onClick()}
    >
      <div className="report-link-card-content">
        <img src={reportImages[image]} alt={title} />
        <div className="report-link-card-text-content">
          <h3>{title}</h3>
          {description && (
            <span data-testid="description" className="report-link-card-description">
              {description}
            </span>
          )}
        </div>
      </div>
      <FaIcon className="report-link-icon" icon={icon} />
    </button>
  );
};

export default ReportLinkCard;
